import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { Router, RouterStateSnapshot } from "@angular/router";
import { Sort } from "@angular/material/sort";
import { PageEvent } from "@angular/material/paginator";
import { PaginationInstance } from "../../../../node_modules/ngx-pagination/dist/ngx-pagination.module";
import { FormBuilder } from "@angular/forms";
import { MatSnackBar } from "@angular/material";

import { DataService } from "./../../data.service";
import { AppConfig } from "./../../config";
import { MockupInput } from "./../../mockup-input";

@Component({
  selector: "app-metaobjectlist",
  templateUrl: "./metaobjectlist.component.html",
  styleUrls: ["./metaobjectlist.component.scss"],
})
export class MetaobjectListComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) set mscontent(ms: MatSort) {
    this.matSort = ms;
  }

  @ViewChild(MatPaginator, { static: false }) set mpcontent(mp: MatPaginator) {
    this.paginator = mp;
  }

  pageEvent: PageEvent;

  public paginationConfig: PaginationInstance = {
    id: "advanced",
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0,
  };

  matSort: MatSort;
  paginator: MatPaginator;
  metaobjectList = [];
  displayedColumns: string[] = [
    "id",
    "label",
    "parentobjectname",
    "standard",
    "description",
    "embeddedobject",
    "modifiedby",
    "modifieddate",
    "active",
  ];
  dataSource = new MatTableDataSource();

  appPageSizeOptions = this.appConfig.appPageSizeOptions;
  appDefaultPageSize = this.appConfig.appDefaultPageSize;

  isLoading = false;
  isError = false;
  errorMessage = "";

  sorting = {
    fieldName: "createddate",
    order: "ASC",
  };

  sortData(sort: Sort) {
    console.log("sort", sort);
    if (!sort.active || sort.direction === "") {
      //default sorting
      this.sorting.fieldName = "createddate";
      this.sorting.order = "ASC";
    } else {
      const isAsc = sort.direction.toLocaleUpperCase() === "ASC";
      this.sorting.fieldName = sort.active;
      if (isAsc) {
        this.sorting.order = "ASC";
      } else {
        this.sorting.order = "DESC";
      }
    }
    this.getMetaObjectList();
  }

  pageChanged(pe: PageEvent) {
    console.log("pageevent", pe);
    this.paginationConfig.itemsPerPage = pe.pageSize;

    this.paginationConfig.currentPage = pe.pageIndex + 1;
    this.getMetaObjectList();
  }
  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private mockupInput: MockupInput,
    private router: Router,
    public snackBar: MatSnackBar,
    private appConfig: AppConfig
  ) {}

  ngOnInit() {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;

    this.paginationConfig.itemsPerPage = this.appDefaultPageSize;
    this.paginationConfig.currentPage = 1;

    this.getMetaObjectList();
  }

  newMetaobject() {
    this.router.navigateByUrl("/home/metaobject/new");
  }

  getMetaObjectList() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),

      data: {
        pagination: true,
        pagenum: this.paginationConfig.currentPage,
        pagesize: this.paginationConfig.itemsPerPage,
        sortfield: this.sorting.fieldName,
        sortorder: this.sorting.order,
      },
    };

    this.isLoading = true;
    console.log(postOption);
    this.dataService.getMetaObjects(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          console.log("success");
          this.paginationConfig.totalItems = res.data.totalrows;
          this.metaobjectList = res.data.metaobject;

          //assign table data will refresh it automatically
          this.dataSource.data = this.metaobjectList;
          this.matSort._stateChanges.next();
          this.isLoading = false;
        } else {
          console.log("no data");
          this.paginationConfig.itemsPerPage = 10;
          this.paginationConfig.currentPage = 1;
          this.paginationConfig.totalItems = 0;

          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
